import { useEffect, useState } from "react";

type DriverFormState = {
  driver: string[];
};

export type DriverSlots = {
  driversQuantity: number;
  setDriversQuantity: React.Dispatch<React.SetStateAction<number>>;
  inputDriverChange: (value?: string, index?: number) => void;
  inputClearDriver: (idx: number) => void;
};

export const useDriverSlots = <T extends DriverFormState>(
  driver: string[] | undefined,
  setForm: React.Dispatch<React.SetStateAction<T>>,
  maxDrivers: number
): DriverSlots => {
  const [driversQuantity, setDriversQuantity] = useState(Math.min(driver?.length || 1, maxDrivers));
  const driversLength = driver?.length ?? 0;

  useEffect(() => {
    if (driversLength > maxDrivers) {
      setForm((prev) => ({
        ...prev,
        driver: prev.driver.slice(0, maxDrivers),
      }));
      setDriversQuantity(maxDrivers);
      return;
    }

    setDriversQuantity(driversLength || 1);
  }, [driversLength, maxDrivers, setForm]);

  const inputDriverChange = (value?: string, index?: number) => {
    if (!value) return;

    setForm((prev) => {
      const newDrivers = [...prev.driver];

      if (index !== undefined && index < newDrivers.length) {
        newDrivers[index] = value;
      } else {
        newDrivers.push(value);
      }

      return {
        ...prev,
        driver: newDrivers,
      };
    });
  };

  const inputClearDriver = (idx: number) => {
    setForm((prev) => {
      const newDrivers = prev.driver.filter((_, i) => i !== idx);

      return {
        ...prev,
        driver: newDrivers,
      };
    });

    setDriversQuantity((prev) => Math.max(1, prev - 1));
  };

  return { driversQuantity, setDriversQuantity, inputDriverChange, inputClearDriver };
};
